<template>
  <div class="re-watching">
    <div class="text-center">
      <h1 class="dastnevis py-5">داستان کتاب را ببینیم</h1>
      <div class="re-video py-5" v-if="book">
        <div class="r1_iframe_embed" v-if="book.videoUrl">
          <iframe
            :src="book.videoUrl"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen="true"
            webkitallowfullscreen="true"
            mozallowfullscreen="true"
          />
        </div>
        <div v-else>
          <v-alert>محتوایی برای نمایش وجود ندارد</v-alert>
        </div>
      </div>
    </div>

    <MenuComponent :book-id="this.$route.params.id" state="watching" />
  </div>
</template>

<script>
import MenuComponent from "./Menu.vue";
export default {
  name: "watching-component",
  components: { MenuComponent },
  data() {
    return {
      book: null
    };
  },
  created() {
    this.getBook();
  },
  methods: {
    getBook() {
      this.$api.get("/book/" + this.$route.params.id).then((res) => {
        this.book = res.data.book;
      });
    }
  }
};
</script>

<style>
.re-video {
  margin: 0 auto;
}
.re-video .plyr--video {
  background: white;
  border-radius: 20px;
}
.re-video .plyr__video-wrapper {
  background: transparent;
}
.r1_iframe_embed {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: auto;
  padding-top: 56.25%;
}
.r1_iframe_embed iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}
</style>
